import {
    CellData,
    columnVisibilityFeature,
    createSortedRowModel,
    RowData,
    rowSelectionFeature,
    rowSortingFeature,
    sortFns,
    ColumnDef as TanStackColumnDef,
    tableFeatures,
} from '@tanstack/react-table';

export const features = tableFeatures({
    columnVisibilityFeature,
    rowSelectionFeature,
    rowSortingFeature,
    sortedRowModel: createSortedRowModel(),
    sortFns,
});

export type Features = typeof features;

export type ColumnDef<
    TData extends RowData,
    TValue extends CellData = CellData
> = TanStackColumnDef<Features, TData, TValue>;
